/* =====================
   Ajoutez ici votre propre javascript personnalisé
   ===================== */

/* Cart drawer: "order reserved" countdown (coach call 27/10).
   The cart drawer body is swapped by cart.js after every cart change (scripts inside it do not run),
   so the countdown lives here and just updates whatever #cart-countdown-timer is currently in the DOM.
   The end time is kept in sessionStorage so it does not restart on every page load, and is cleared
   when the cart is empty so the next cart gets a fresh timer. */
(function () {
  var KEY = 'mjCartReserveEnd';

  function tick() {
    var el = document.getElementById('cart-countdown-timer');
    if (!el) {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      return;
    }

    var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (!end) {
      end = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
    }

    var left = end - Date.now();
    if (left <= 0) {
      var wrap = el.closest('.cart-countdown-timer-wrapper');
      if (wrap) { wrap.textContent = wrap.getAttribute('data-end-message') || ''; }
      return;
    }

    var m = Math.floor(left / 60000);
    var s = Math.floor((left % 60000) / 1000);
    el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
  }

  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);
  window.addEventListener('updated.shopiweb.cart', tick);
})();
